/**
 * Add or modify a query parameter on a url
 *
 * @param {string} url
 * @param {string} key
 * @param {string} val
 * @return {string}
 */
export function url_query_set (url, key, val) {
  var has_query_string = url.includes('?');
  var has_query_param = url.includes(`${key}=`);

  if (has_query_param) {
    var rxp = new RegExp(`${key}=[^&?]+`, 'i');
    return url.replace(rxp, `${key}=${val}`);
  }

  return `${url}${has_query_string ? '&' : '?'}${key}=${val}`;
}

/**
 * Retrieve a query parameter from a url
 *
 * @param {string} url
 * @param {string} key
 * @return {string}
 */
export function url_query_get (url, key) {
  var rxp = new RegExp(`${key}=([^&?]+)`, 'i');
  var matches = url.match(rxp);

  if (matches && matches[1]) {
    return matches[1];
  }

  return null;
}

/**
 * Remove a query parameter from a url
 *
 * @param {string} url
 * @param {string} key
 */
export function url_query_unset (url, key) {
  var rxp = new RegExp(`([?&])${key}=[^&?]+&?`, 'gi');
  url = url.replace(rxp, '$1');

  // remove trailing ?
  if (url[url.length - 1] === '?') {
    return url.substr(0, url.length - 1);
  }

  return url;
}
